export const CLAVES = {
  aceptacion: 'ppt_acceptance_v1',
  clases: 'ppt_classes_v1',
  personalizados: 'ppt_custom_exercises_v1',
  favoritos: 'ppt_favorites_v1',
  borrador: 'ppt_active_draft_v1',
  preferencias: 'ppt_preferences_v1'
} as const

let disponible: boolean | null = null

export function almacenamientoDisponible(): boolean {
  if (disponible !== null) return disponible
  try {
    const prueba = '__ppt_test__'
    window.localStorage.setItem(prueba, '1')
    window.localStorage.removeItem(prueba)
    disponible = true
  } catch {
    disponible = false
  }
  return disponible
}

export function leer<T>(clave: string, porDefecto: T): T {
  if (!almacenamientoDisponible()) return porDefecto
  try {
    const crudo = window.localStorage.getItem(clave)
    if (!crudo) return porDefecto
    return JSON.parse(crudo) as T
  } catch {
    return porDefecto
  }
}

export function escribir(clave: string, valor: unknown): boolean {
  if (!almacenamientoDisponible()) return false
  try {
    window.localStorage.setItem(clave, JSON.stringify(valor))
    return true
  } catch {
    return false
  }
}

export function borrar(clave: string): void {
  if (!almacenamientoDisponible()) return
  try {
    window.localStorage.removeItem(clave)
  } catch {
    /* sin acción: el almacenamiento no está disponible */
  }
}
